import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

const SelectBox = ({
    selected,
    setSelected,
    options,
    isMobile,
    placeholder = 'Select option',
}) => {
    const hasSelection = selected && Object.keys(selected).length > 0;

    return (
        <div className="w-full">
            <Listbox value={selected} onChange={setSelected}>
                <div className="relative mt-1">
                    <Listbox.Button className={`relative w-full cursor-default rounded-lg dark:bg-white/5 bg-customBlack/5 py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 ${isMobile ? 'text-xs' : 'text-sm'}`}>
                        <span className="flex min-h-[1.5rem] items-center gap-2 truncate dark:text-customFontMilkWhite text-customBlack/90">
                            {hasSelection && selected.icon && (
                                <img
                                    src={selected.icon}
                                    alt={selected.name}
                                    className="h-5 w-5 rounded-full object-contain"
                                />
                            )}
                            <span className="block truncate">
                                {hasSelection ? selected.name : placeholder}
                            </span>
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className={`absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none ${isMobile ? 'text-xs' : 'text-sm'}`}>
                            {options.map((person, personIdx) => (
                                <Listbox.Option
                                    key={personIdx}
                                    className={({ active }) =>
                                        `relative cursor-default select-none py-2 pl-3 pr-4 ${active ? 'bg-custom_dark_secondary/10 text-gray-900' : 'text-gray-900'
                                        }`
                                    }
                                    value={person}
                                >
                                    {({ selected }) => (
                                        <>
                                            <span className="flex items-center gap-3">
                                                {person.icon && (
                                                    <img
                                                        src={person.icon}
                                                        alt={person.name}
                                                        className="h-6 w-6 rounded-full object-contain"
                                                    />
                                                )}
                                                <span
                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                        }`}
                                                >
                                                    {person.name}
                                                </span>
                                            </span>
                                            {selected ? (
                                                <span className="absolute inset-y-0 right-2 flex items-center text-custom_dark_background">
                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    )
}

export default SelectBox
